<template>
  <div class="disability-filter">
    <div class="resumes-filter">
      <div class="resume-filter disability dropdown">
        <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" @click="toggleDisabilityFilters">
          {{ selectedDisability ? $t('components.resumes_disability_filter.disabled_worker') : $t('components.resumes_disability_filter.all_profiles') }}
          <v-sprite color="#7556ed" icon="dropdown_arrow" />
        </button>

        <ul class="dropdown-menu" :class="{ show: showDisabilityFilters }">
          <li>
            <a
              href="#"
              class="dropdown-item"
              :class="{ active: selectedDisability === false }"
              @click.prevent="selectDisability(false)">
              <v-checkbox-indicator :checked="selectedDisability === false" color="#7556ed" />
              {{ $t('components.resumes_disability_filter.all_profiles') }}
            </a>
          </li>
          <li>
            <a
              href="#"
              class="dropdown-item"
              :class="{ active: selectedDisability === true }"
              @click.prevent="selectDisability(true)">
              <v-checkbox-indicator :checked="selectedDisability === true" color="#7556ed" />
              {{ $t('components.resumes_disability_filter.disabled_worker') }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ResumesDisabilityFilter',
  props: {
    selectedDisability: {
      type: [Boolean, null],
      default: false,
    },
  },
  emits: ['update:selectedDisability'],
  data() {
    return {
      showDisabilityFilters: false,
    };
  },
  methods: {
    selectDisability(disability: boolean): void {
      this.$emit('update:selectedDisability', disability);
      this.toggleDisabilityFilters();
    },

    toggleDisabilityFilters(): void {
      this.showDisabilityFilters = !this.showDisabilityFilters;
    },
  },
});
</script>

<style scoped lang="scss">
@import '../../scss/config/config';

.resumes-filter {
  display: flex;
  justify-content: end;
  margin: 0 16px 0 0;
}

.dropdown-toggle {
  background: #fff;
  border: 0;
  border-radius: 15px;
  color: $purple;
  padding: 10px;

  &::after {
    content: none;
  }

  svg {
    margin-left: 18px;
    transition: transform .3s;
  }
}

.dropdown-item {
  display: inline-flex;
  font-size: 14px;
  gap: 5px;
}

.dropdown-item.active {
  svg {
    fill: $primary !important;
  }

  .checkbox-indicator {
    border: 1px solid $primary;
  }

  color: $primary;
  font-weight: 600;
}

.resume-filter {
  &:has(.dropdown-menu.show) {
    .dropdown-toggle svg {
      transform: rotate(180deg);
    }
  }
}
</style>
